// extracted by mini-css-extract-plugin
export default {"container":"mainLayout_container__Gdz6i","main":"mainLayout_main__sF5s1"};